import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Card, Icon, Button } from 'antd';
import PropTypes from 'prop-types';
import { isLoggedInUser } from '../../../util/isLoggedInUser';
import QuoteRequestCard from '../quoteRequest/QuoteRequestCard';

/**
 * @component
 * @category Search Page
 * @name ContactFormSet
 * @description Shown above the results when a search returns no rates. Two paths:
 *  - Signed-in customers get a "Create RFQ" shortcut into the RFQ creator (we
 *    already have their details).
 *  - Guests get {@link QuoteRequestCard}, which captures the zero-result lead
 *    through the pf-comms proxy (own captcha + submit → CRM QUOTE activity +
 *    Front ping). This replaced a legacy name/email form that posted the quote
 *    request DIRECTLY to Betty from the browser — the card both enriches the
 *    CRM and removes that direct BB exposure.
 * **Example**
 * ```js
 *   <ContactFormSet />
 * ```
 */
class ContactFormSet extends Component {
  render() {
    const { searchContactFormHeader, searchContactFormSubHeader, secondaryColor } = this.props;
    const isLoggedIn = isLoggedInUser(this.props.userDetails);
    const goToRfqCreator = () => this.props.history.push('/rfq/new', { source: 'noRates' });

    return (
      <Card
        title={
          <div style={{ whiteSpace: 'pre-wrap' }}>
            <h1 style={{ color: 'black' }}>{searchContactFormHeader}</h1>
            <span style={{ fontSize: '12px' }}>
              {isLoggedIn
                ? 'Create an RFQ and we’ll get competitive quotes for this lane.'
                : searchContactFormSubHeader}
            </span>
          </div>
        }
        style={{
          borderRadius: '5px',
          boxShadow: '0 1px 5px rgba(0, 0, 0, 0.15)',
          background: 'white',
          height: 'auto',
          margin: '0px 0px 15px 0px',
        }}
      >
        {isLoggedIn ? (
          <div className="testR1">
            <Button
              type="primary"
              onClick={goToRfqCreator}
              style={{
                border: 'none',
                color: '#fff',
                background: secondaryColor,
                borderBottom: `2px solid rgba(128,128,128,0.9)`,
                fontSize: '16px',
                borderRadius: '5px',
              }}
            >
              <Icon type="thunderbolt" /> Create RFQ
            </Button>
          </div>
        ) : (
          <QuoteRequestCard />
        )}
      </Card>
    );
  }
}

ContactFormSet.propTypes = {
  /**
   * secondary color of web app
   */
  secondaryColor: PropTypes.string,
  /**
   * whether to show contact form
   */
  showSearchContactForm: PropTypes.bool,

  /**
   * Header text for Contact form above all result cards on search page.
   */
  searchContactFormHeader: PropTypes.string,
  /**
   * Sub Header text description for Contact form above all result cards on search page.
   */
  searchContactFormSubHeader: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    secondaryColor: state.code_config.secondaryColor,
    showSearchContactForm: state.route.showSearchContactForm,
    // gates the signed-in "Create RFQ" shortcut (vs the guest QuoteRequestCard).
    userDetails: state.route.USER_DETAILS,

    searchContactFormHeader: state.code_config.searchContactFormHeader,
    searchContactFormSubHeader: state.code_config.searchContactFormSubHeader,
  };
};

export default withRouter(connect(mapStateToProps)(ContactFormSet));
